module.exports = __webpack_public_path__ + "img/2dfc3aa9-6317-4f50-9672-d6e956884dbb.4811940f.png";